import axios from 'axios';
import entities from "../config/entities";
import BaseService from './BaseService';

let mockData = [
  {
    id:1,
    country_code: 'nl',
    country: 'Netherlands',
    primary: true,
    active: true
  },
  {
    id:2,
    country_code: 'be',
    country: 'Belgium',
    primary: false,
    active: true
  },
  {
    id:3,
    country_code: 'fr',
    country: 'France',
    primary: false,
    active: false
  }
];

class CountryService extends BaseService{
  constructor() {
    super({ path: 'countries' });
  }
  async get() {
    let data = await axios.get('/countries?match[active]=true', {
      params: {
        limit: 500
      }
    });
    return data;
  }
  async getAll(params) {
    return super.get(params)
  }

  async getById(id) {
    let job = mockData.find(d => d.id === id) || {};
    return {data: job};
  }

  async create(data) {
    return {
      data: {
        id: mockData[mockData.length - 1].id + 1,
        ...data
      }
    }
  }
}

export default new CountryService();
